export const getElement = (
  e: string | HTMLElement | null | undefined
): HTMLElement | null => {
  if (e === null || e === undefined) return null;

  if (typeof e === "string") {
    try {
      return document.querySelector(e);
    } catch {
      return null;
    }
  }

  return e;
};
